import posthog from 'posthog-js';

export const POSTHOG_KEY = 'phc_Ye6PZcKA1G3eBslJ30GVefxMWLBZZEWEBLhoeQVgi5f';

// Sends an event to PostHog and Google Analytics. Names and properties follow
// GA4's recommended events (file_download, purchase, generate_lead) so they
// show up in GA's standard reports. Both tools only load in production builds,
// so this does nothing in `gatsby develop`.
export const track = (event, properties = {}) => {
  if (typeof window === 'undefined') {
    return;
  }
  if (posthog.__loaded) {
    posthog.capture(event, properties);
  }
  if (typeof window.gtag === 'function') {
    window.gtag('event', event, properties);
  }
};
